export default {
  'admin.marketplace.title': 'Marketplace Curation',
  'admin.marketplace.search': 'Search by name',
  'admin.marketplace.filters.all': 'All',
  'admin.marketplace.filters.featured': 'Featured',
  'admin.marketplace.empty': 'No public subscriptions match your filters.',
  'admin.marketplace.column.name': 'Name',
  'admin.marketplace.column.owner': 'Owner',
  'admin.marketplace.column.total': 'Total Price',
  'admin.marketplace.column.features': 'Features',
  'admin.marketplace.column.clones': 'Clones',
  'admin.marketplace.column.public': 'Public',
  'admin.marketplace.column.featured': 'Featured',
  'admin.marketplace.column.created': 'Created',
  'admin.marketplace.publicYes': 'Public',
  'admin.marketplace.toggle.success': 'Featured flag updated',
  'admin.marketplace.toggle.error': 'Failed to update featured flag',
  'admin.marketplace.features.title': 'Feature Marketplace Curation',
  'admin.marketplace.features.empty': 'No public features match your filters.',
  'admin.marketplace.features.column.title': 'Title',
  'admin.marketplace.features.column.price': 'Price',
};
